<template>
  <div class="running-box east-scroll">
    <div id="running-app" class="running-app" v-cloak>
      <ul class="task-list" v-if="records.length">
        <li class="task-item" v-for="record in records" :key="record.id">
          <template v-if="info && record.id === info.id">
            <div class="task-item-left">
              <record-info :record="record"></record-info>
              <div class="task-item-left-row">
                <div class="row-left">
                  <b>开始时间：</b>{{ record.startTimeText }} <b>当前阶段：</b
                  >{{ info.phaseText }} (<span v-if="info.total === -2">-</span
                  ><span v-else-if="info.total === -1">数量统计中</span
                  ><span v-else
                    >{{ info.finished
                    }}<span v-if="info.total >= 0"
                      >/{{ info.total }}</span
                    ></span
                  >) <b>异常数量：</b>{{ info.error }}
                </div>
                <div class="row-right">
                  {{ (serverTime - record.startTimeStamp) | toTimer }}
                </div>
              </div>
              <div class="task-item-left-row">
                <b>当前操作：</b>{{ info.operation }}
              </div>
            </div>
            <div class="task-item-right" style="display: none;">
              <button class="btn-stop">终止</button>
            </div>
            <div class="progress-box">
              <div class="progress-box-bar" :style="{ width: percent }"></div>
            </div>
          </template>
          <template v-else>
            <div class="task-item-left">
              <record-info :record="record"></record-info>
              <div class="task-item-left-row">
                <div class="row-left">
                  <b>开始时间：</b>未开始 <b>当前阶段：</b>未初始化
                  <b>异常数量：</b>0
                </div>
                <div class="row-right"></div>
              </div>
              <div class="task-item-left-row"><b>当前操作：</b>等待中...</div>
            </div>
            <div class="task-item-right" style="display: none;">
              <button class="btn-stop">终止</button>
            </div>
            <div class="progress-box">
              <div class="progress-box-bar"></div>
            </div>
          </template>
        </li>
      </ul>
      <ul class="task-list no-data" v-else>
        <li class="task-item">没有执行中或等待执行的任务</li>
      </ul>
    </div>
  </div>
</template>

<script>
import recordInfo from "./record-info";
import { DN_PREFIX } from "@/constant/extensionTask";
import { TASK_PHASE_TEXT } from "@/constant/taskPhase";
import { mapState } from "vuex";
import dateFormat from "@/filter/dateFormat";

export default {
  data() {
    return {
      serverTime: Date.now(),
      timeDelta: 0,
      records: [],
      info: null,
      destroyed: false
    };
  },
  computed: {
    ...mapState(["descriptors"]),
    percent() {
      if (this.info) {
        let percent = this.info.phase / this.phaseNum;
        if (this.info.total > 0) {
          percent += this.info.finished / this.info.total / this.phaseNum;
        }
        return percent * 100 + "%";
      }
      return "0%";
    }
  },
  async created() {
    this.TASK_PHASE_TEXT = TASK_PHASE_TEXT;
    this.phaseNum = Object.keys(this.TASK_PHASE_TEXT).length;

    // 等待Store初始化完成
    await this.$store.init;
    this.serviceDic = this.descriptors
      .filter(d => d.interfaceTypeName === "ISyncService")
      .reduce((obj, d) => ({ ...obj, [d.name]: d.friendlyName }), {});

    // 加载SignalR
    await this.loadScripts();
    this.connectionInit();
    this.start();
  },
  mounted() {
    this.updateTime();
  },
  destroyed() {
    this.destroyed = true;
    this.stop();
  },
  updated() {},
  methods: {
    updateTime: function() {
      this.serverTime = Date.now() + this.timeDelta;
      setTimeout(this.updateTime, 1000);
    },
    connectionInit() {
      this.connection = new window.signalR.HubConnectionBuilder()
        .withUrl(process.env.VUE_APP_BASE_API + "sync/hub")
        .build();
      this.connection.on("time", time => (this.timeDelta = time - Date.now()));
      this.connection.on(
        "records",
        records => (this.records = records.map(this.recordFilter))
      );
      this.connection.on("info", info => (this.info = this.infoFilter(info)));
      this.connection.onclose(async () => {
        if (!this.destroyed) {
          await this.start();
        }
      });
    },
    async stop() {
      await this.connection.stop();
      console.log("disconnected");
    },
    async start() {
      try {
        await this.connection.start();
        console.log("connected");
      } catch (err) {
        console.log(err);
        setTimeout(() => this.start(), 5000);
      }
    },
    async loadScripts() {
      await this.$loadScript(process.env.BASE_URL + "jquery/jquery.js");
      await this.$loadScript(process.env.BASE_URL + "signalr/signalr.js");
    },
    recordFilter(record) {
      if (record.dn.startsWith(DN_PREFIX)) {
        let service = this.serviceDic[record.dn.slice(DN_PREFIX.length)];
        if (service) {
          record.dn = service;
        }
      }
      if (record.startTime) {
        let startTime = new Date(record.startTime);
        record.startTimeStamp = startTime.getTime();
        record.startTimeText = dateFormat(startTime);
      } else {
        record.startTimeStamp = 0;
        record.startTimeText = "未开始";
      }
      return record;
    },
    infoFilter(info) {
      info.phaseText = this.TASK_PHASE_TEXT[info.phase];
      return info;
    }
  },
  components: {
    recordInfo
  }
};
</script>

<style lang="less" scoped>
.running-box {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
  overflow: auto;
}

.running-app {
}

.task-list {
  @row-height: 22px;
  @item-padding: 4px;
  @item-height: @row-height * 3;
  //@right-width: 60px;
  @right-width: 10px;
  @row-right-width: 60px;
  .task-item {
    color: #333;
    position: relative;
    height: @item-height;
    margin: 6px;
    padding: @item-padding 0;
    border: 1px solid #ccc;
    border-radius: 3px;
    overflow: hidden;
    box-sizing: content-box;

    .task-item-left {
      position: relative;
      z-index: 10;
      margin-left: 10px;
      margin-right: @right-width;
      font-size: 12px;
      height: 100%;
      overflow: hidden;
      .task-item-left-row {
        position: relative;
        height: @row-height;
        line-height: @row-height;
        white-space: nowrap;
        .row-left {
          margin-right: @row-right-width;
          height: @row-height;
          overflow: hidden;
          b:nth-of-type(n + 2) {
            margin-left: 40px;
          }
        }
        .row-right {
          text-align: right;
          position: absolute;
          top: 0;
          right: 0;
          height: @row-height;

          width: @row-right-width;
        }
      }
    }
    .task-item-right {
      position: absolute;
      z-index: 10;
      top: @item-padding;
      right: 0;
      height: @item-height;
      line-height: @item-height;
      width: @right-width;
      text-align: center;
      > button {
        position: relative;
        top: -1px;
        font-size: 12px;
        line-height: 14px;
        background: #f8f8f8;
        border: 1px solid #ccc;
        padding: 3px;
        border-radius: 3px;
      }
      > .btn-stop {
        color: #fff;
        background: #ff3333;
        border-color: #f00;
      }
    }
  }
  &.no-data {
    li {
      text-align: center;
      font-size: 17px;
      line-height: @item-height;
      background-color: #eeeeee;
    }
  }
}

.progress-box {
  position: absolute;
  //z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
  background-color: #fff;
  background-image: linear-gradient(
    to bottom,
    #ffffff 0%,
    #f2f2f2 45%,
    #f6f6f6 100%
  );
  .progress-box-bar {
    width: 0;
    height: 100%;
    background-color: #c8ffc8;
    background-image: linear-gradient(
      to bottom,
      #c8ffc8 0%,
      #8cff8c 45%,
      #b4ffb4 100%
    );
  }
}
</style>
